enum UserTypeOrganization {
    Lantis = 1,
    Contractor = 2,
    Stakeholder = 3,
}

export default UserTypeOrganization;
